var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 0.333374C7.96516 0.333374 0.333496 7.96504 0.333496 17C0.333496 26.035 7.96516 33.6667 17.0002 33.6667C26.0352 33.6667 33.6668 26.035 33.6668 17C33.6668 7.96504 26.0352 0.333374 17.0002 0.333374ZM17.0002 8.66671C19.8785 8.66671 22.0002 10.7867 22.0002 13.6667C22.0002 16.5467 19.8785 18.6667 17.0002 18.6667C14.1235 18.6667 12.0002 16.5467 12.0002 13.6667C12.0002 10.7867 14.1235 8.66671 17.0002 8.66671ZM8.49016 24.9534C9.98516 22.7534 12.4785 21.2867 15.3335 21.2867H18.6668C21.5235 21.2867 24.0152 22.7534 25.5102 24.9534C23.3802 27.2334 20.3585 28.6667 17.0002 28.6667C13.6418 28.6667 10.6202 27.2334 8.49016 24.9534Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b673e5d0.svg";
export { ForwardRef as ReactComponent };